import React from 'react';

import { Switch } from 'react-router-dom';

import RecuperarSenha from '~/pages/RecuperarSenha';
import EsqueciSenha from '~/pages/EsqueciSenha';
import RedefinirSenhaAdministrador from '~/pages/RedefinirSenhaAdministrador';
import Route from './Route';

import Login from '../pages/Login';
import Home from '../pages/Home';
import TrocarSenha from '../pages/TrocarSenha';

export default function Routes() {
  return (
    <Switch>
      <Route path="/" exact component={Login} />
      <Route path="/esqueci-senha" exact component={EsqueciSenha} />
      <Route
        path="/recuperar-senha/administrador"
        exact
        component={RedefinirSenhaAdministrador}
      />
      <Route path="/recuperar-senha/:tipo" exact component={RecuperarSenha} />
      <Route path="/trocar-senha" exact component={TrocarSenha} />
      <Route path="/home" component={Home} isPrivate />

      <Route path="/" component={() => 
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
        <h1>ERRO: 404</h1>
        <h1>Página não encontrada</h1>
        </div>} />
    </Switch>
  );
}
